@if (systematics$ | async; as systematics) {
  @if (lastSystematicTitle()) {
    <button
      app-button
      (click)="onOpenEducationalProjectModal(systematics)"
      class="hover:bg-modules-pedagogical-600 border-b-modules-pedagogical-500 hover:border-b-modules-pedagogical-400 bg-modules-pedagogical-100 hover:border-modules-pedagogical-600 hover:text-white text-modules-pedagogical-600 group cursor-pointer hover:brightness-100! transition overflow-hidden justify-start! duration-300 items-center p-4 gap-3 w-full border-b-[3px] border-solid! rounded-xl"
    >
      <svg-icon
        class="text-modules-pedagogical-600 w-10 h-10 group-hover:transition group-hover:duration-300 block group-hover:text-white"
        src="assets/icons/icon-systematic.svg"
      ></svg-icon>

      <div
        class="text-modules-pedagogical-700 group-hover:transition z-50 h-12 group-hover:duration-300 flex items-center justify-center flex-col"
      >
        <h1 class="group-hover:text-white w-full max-w-[16rem] text-lg truncate font-semibold">
          {{ lastSystematicTitle() }}
        </h1>
      </div>
      <div class="absolute w-20 h-20 block -rotate-25 right-0 bottom-0 z-0">
        <svg-icon
          class="text-modules-pedagogical-200 fill-none stroke-1"
          src="assets/icons/icon-systematic.svg"
        ></svg-icon>
      </div>
    </button>
  }
}
